module.exports = __webpack_public_path__ + "images/setupguide/keyfeature-company-list.png";